require('/opt/odin/app/frontend/components/create_account/index.module.scss');module.exports = "../../app/cells/components/create_account/show.erb";